"use client";

import React, { useState } from "react";
import Link from "next/link";
import { ChevronDown, Layers } from "lucide-react";
import { usePublicContext } from "@/modules/public/home/context/PublicContext";

export default function NavRibbon() {
  const { categories, subcategories } = usePublicContext();
  const [activeCategory, setActiveCategory] = useState<string | null>(null);

  const STATIC_PRE_LINKS = [
    { label: "Home", href: "/" },
  ];

  const STATIC_POST_LINKS = [
    { label: "FPO Connect", href: "/fpo-connect" },
    { label: "Vendor Profile ", href: "/vendor-profile" },
    { label: "Israel Agritech", href: "/israel-agritech" },
    { label: "About Us", href: "/about" },
    { label: "Contact Us", href: "/contact" },
  ];

  return (
    <nav
      className="hidden lg:block bg-white sticky top-20 z-40 h-14 border-b border-slate-200/80 shadow-xs"
      aria-label="Main navigation"
    >
      <div className="max-w-[1800px] mx-auto px-6 lg:px-8 h-full">
        <ul className="flex items-center justify-center gap-8 h-full">
          {/* Static Pre-Links */}
          {STATIC_PRE_LINKS.map((link) => (
            <li key={link.href} className="h-full flex items-center">
              <Link
                href={link.href}
                className="text-slate-800 font-bold text-[13px]  tracking-wider hover:text-green-800 hover:scale-[1.02] transition-all h-full flex items-center"
              >
                {link.label}
              </Link>
            </li>
          ))}

          {/* Dynamic Categories Dropdowns */}
          {categories.map((cat) => {
            const catSubs = subcategories.filter((sub) => {
              const subCatId = typeof sub.category === "object" && sub.category !== null
                ? (sub.category as any)._id
                : sub.category;
              return subCatId === cat._id;
            });
            const isDropdownActive = activeCategory === cat._id;

            return (
              <li
                key={cat._id}
                className="relative h-full flex items-center"
                onMouseEnter={() => setActiveCategory(cat._id)}
                onMouseLeave={() => setActiveCategory(null)}
              >
                <Link
                  href={`/${cat.slug}`}
                  className={`text-slate-800 font-bold text-[13px]  tracking-wider transition-all flex items-center gap-1 h-full hover:scale-[1.02] ${isDropdownActive ? "text-[#005a2b]" : "hover:text-[#005a2b]"
                    }`}
                >
                  {cat.name}
                  {catSubs.length > 0 && (
                    <ChevronDown
                      className={`w-3.5 h-3.5 text-slate-400 transition-transform duration-200 shrink-0 ${isDropdownActive ? "text-green-800 rotate-180" : ""
                        }`}
                    />
                  )}
                </Link>

                {/* Dropdown Box */}
                {catSubs.length > 0 && isDropdownActive && (
                  <div className="absolute top-full left-0 mt-0 bg-white text-slate-800 rounded-b-xl shadow-lg border border-slate-200/50 min-w-[220px] z-[999] p-2 animate-fade-in">
                    <div className="py-1">
                      {catSubs.map((sub) => (
                        <Link
                          key={sub._id}
                          href={`/${cat.slug}/${sub.slug}`}
                          className="flex items-center gap-2 px-4 py-2.5 text-xs font-bold text-slate-700 hover:bg-green-50 hover:text-green-800 rounded-lg transition-all"
                          onClick={() => setActiveCategory(null)}
                        >
                          <Layers className="w-3.5 h-3.5 text-slate-400 shrink-0" />
                          {sub.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </li>
            );
          })}

          {/* Static Post-Links */}
          {STATIC_POST_LINKS.map((link) => (
            <li key={link.href} className="h-full flex items-center">
              <Link
                href={link.href}
                className="text-slate-800 font-bold text-[13px]  tracking-wider hover:text-green-800 hover:scale-[1.02] transition-all h-full flex items-center"
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
